
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Font } from "@/types/fonts";
import { Prop } from "vue-property-decorator";
import BrandTypographyFont from "./BrandTypographyFont.vue";
import { singularityStore } from "@/store/store";

@Component({
  components: {
    BrandTypographyFont
  }
})
export default class BrandTypographyPicker extends Vue {
  isOverlayOpen = false;
  @Prop()
  value?: Font["slug"];

  @Prop({ default: "Body" })
  label!: string;

  update(font: Font) {
    singularityStore.setSingularityLeftPanel("brand");
    this.$emit("update", font);
  }

  openTypographyEditPanel() {
    singularityStore.setSingularityLeftPanel("brand_edit_typography");
    singularityStore.setCurrentFont(
      this.label === "Body" ? "body_font" : "heading_font"
    );
  }
}
